import apiFetch from '../apiFetch'

export default function (token, massiveDownload) {
  return apiFetch({ endPoint: 'Document/MassiveDownload/CreateMassiveDownload', method: 'PUT', body: massiveDownload, token: token })
}
